<template>
  <div>
    <div class="top-breadcrumb">
      <ol class="breadcrumb" style="background-color: white">
        <li class="breadcrumb-item" style="margin-left: 15px">
          <router-link to="" style="color: #8cc63f !important">
            Portfolio Management
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="'/' + authUser.userable_type + '/projects/contracts'"
            >Contracts</router-link
          >
        </li>
      </ol>
    </div>
    <div
      style="display: flex; justify-content: center; margin-top: 60px"
      class="col-12"
    >
      <span
        class="col-1"
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          color: gray;
        "
      >
        <i
          class="fa fa-filter"
          style="font-size: 15px; color: #8cc63f; margin-right: 5px"
        ></i>
        Filter
      </span>
      <span class="col-3">
        <date-range-picker
          ref="picker"
          :locale-data="{
            firstDay: 1,
            format: 'dd-mm-yyyy',
            applyLabel: 'Apply',
            cancelLabel: 'Cancel',
          }"
          :timePicker="false"
          :showDropdowns="true"
          :autoApply="true"
          v-model="dateRange"
          @update="filter()"
          :linkedCalendars="true"
          style="width: 100%; background-color: #fafaf7 !important"
        >
        </date-range-picker>
      </span>
      <span class="col-1">
        <button
          style="font-size: 14px"
          type="button"
          class="btn btn-info"
          @click="clearDateRage()"
        >
          Clear
        </button>
      </span>
      <span class="col-4">
        <select
          class="custom-select"
          v-model="contract_id"
          @change="filter()"
          :showClearButton="true"
        >
          <option v-if="!contract_id" :value="null" disabled selected>
            Select Contract ID
          </option>
          <option v-else :value="null" selected>Clear Selection</option>
          <option
            v-for="contract in contractsList"
            :key="contract.code"
            :value="contract.id"
          >
            {{ contract.code }}
          </option>
        </select>
      </span>
      <span class="col-3">
        <select
          class="custom-select"
          v-model="status"
          @change="filter()"
          :showClearButton="true"
        >
          <option v-if="!status" :value="null" disabled selected>
            Select a Status
          </option>
          <option v-else :value="null" selected>Clear Selection</option>
          <option
            v-for="status in statusList"
            :key="status.name"
            :value="status.id"
          >
            {{ status.name }}
          </option>
        </select>
      </span>
    </div>
    <div style="display: flex; justify-content: center; margin-top: 50px">
      <div
        style="display: flex; justify-content: center; cursor: pointer"
        @click="toggleCreateContractModal()"
      >
        <div>
          <i
            class="fa fa-plus-circle"
            style="font-size: 90px; color: #8cc63f; margin-right: 5px"
          ></i>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            flex-direction: column;
            margin: 0;
            justify-content: center;
            margin-left: 10px;
          "
        >
          <p
            style="
              margin: 0px;
              font-size: 40px;
              margin-bottom: 5px;
              color: #8cc63f;
            "
          >
            ADD
          </p>
          <p style="margin: 0; color: #8cc63f; font-size: 14px">new contract</p>
        </div>
      </div>
    </div>
    <div style="display: flex; justify-content: center; margin-top: 50px">
      <md-card
        class="md-card-stats"
        style="
          background-color: white;
          max-width: 90%;
          border-radius: 15px;
          padding: 40px;
        "
      >
        <table style="text-align: center">
          <thead>
            <tr>
              <th>Contract ID</th>
              <th>Project ID</th>
              <th>Status</th>
              <th>Principal</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Length</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(contract, key) in contracts" :key="key">
              <td>{{ contract.code }}</td>
              <td>{{ contract.project_code }}</td>
              <td>{{ contract.invested_principal }}</td>
              <td>{{ contract.enabled ? "Active" : "Inactive" }}</td>
              <td>{{ contract.start_date }}</td>
              <td>{{ contract.maturity_date }}</td>
              <td>
                {{
                  getContractDuration(
                    contract.start_date,
                    contract.maturity_date
                  )
                }}
              </td>
              <td>
                <i
                  style="cursor: pointer"
                  @click="redirectToProject(contract)"
                  class="fa fa-eye"
                ></i>
                <i
                  style="cursor: pointer"
                  @click="redirectToUpdateContract(contract)"
                  class="fa fa-edit"
                ></i>
              </td>
            </tr>
          </tbody>
        </table>
      </md-card>
    </div>
    <contract-modal
      :active="showContractModal"
      contractType="ProjectContract"
      @closeRequest="toggleCreateContractModal()"
    />
  </div>
</template><script>
import ContractModal from "./components/modals/contractModal.vue";
import sweetAlert from "sweetalert2";
import { mapState } from "vuex";
import ProjectContractsFilter from "../../filters/ProjectContractsFilter";
import moment from "moment";
import DateRangePicker from "vue2-daterange-picker";
export default {
  name: "projectContracts",
  data() {
    return {
      selectedContractId: null,
      showContractModal: false,
      contract_id: null,
      keyword: null,
      status: null,
      statusList: [
        { id: "active", name: "Active" },
        { id: "inactive", name: "InActive" },
        { id: "notstarted", name: "Not Started" },
        { id: "closed", name: "Closed" },
      ],
      contractsList: [],
      dateRange: {
        startDate: null,
        endDate: null,
      },
    };
  },

  components: {
    ContractModal,

    DateRangePicker,
  },
  created: function () {
    var contractFilter = ProjectContractsFilter();
    this.$store
      .dispatch("searchProjectContracts", {
        filter: contractFilter,
        resultMode: "default",
      })
      .then(() => {
        this.contractsList = this.contracts;
      });
  },
  computed: {
    activeContract() {
      // can be not array when paginated
      if (this.contracts && Array.isArray(this.contracts)) {
        return this.contracts.find((c) => c.id == this.selectedContractId);
      }
    },
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      contracts: (state) =>
        state.contractStore.projectContractSearch.projectContracts,
      createProjectContractStatus: (state) =>
        state.contractStore.projectContractCreate.createProjectContractStatus,
      updateProjectContractStatus: (state) =>
        state.contractStore.projectContractUpdate.updateProjectContractStatus,
      deleteProjectContractStatus: (state) =>
        state.contractStore.projectContractDelete.deleteProjectContractStatus,
    }),
  },
  methods: {
    init() {
      this.selectedContractId = null;
      this.showContractModal = false;
      this.$store.dispatch("searchProjectContracts");
    },
    clearDateRage() {
      this.dateRange = {
        startDate: null,
        endDate: null,
      };
      this.filter();
    },
    redirectToProject(contract) {
      this.$router.push(
        "/" +
          this.authUser.userable_type +
          "/project/" +
          contract.project_code +
          "/" +
          contract.project_id
      );
    },
    redirectToUpdateContract(contract) {
      this.$router.push(
        "/" +
          this.authUser.userable_type +
          "/project/" +
          contract.project_id +
          "/contract/update/" +
          contract.id
      );
    },
    getContractDuration(start, end) {
      let duration = moment.duration(moment(start).diff(moment(end)));
      let durationString = "";
      if (duration.years() / -1) {
        durationString += duration.years() / -1 + " Years, ";
      }
      if (duration.months() / -1) {
        durationString += duration.months() / -1 + " Months, ";
      }
      if (duration.days() / -1) {
        durationString += duration.days() / -1 + " Days, ";
      }
      durationString = durationString.substring(0, durationString.length - 2);
      return durationString;
    },
    filter() {
      var contractsFilter = ProjectContractsFilter();
      contractsFilter.text = this.keyword;
      contractsFilter.status = this.status;
      if (this.contract_id) {
        contractsFilter.ids = [this.contract_id];
      }
      if (this.dateRange.startDate != null && this.dateRange.endDate != null) {
        let start_date = moment(this.dateRange.startDate).format("YYYY-MM-DD");
        let end_date = moment(this.dateRange.endDate).format("YYYY-MM-DD");
        let date_range = { startDate: start_date, endDate: end_date };
        contractsFilter.dateRange = date_range;
      }
      this.$store.dispatch("searchProjectContracts", {
        filter: contractsFilter,
        resultMode: "default",
      });
    },
    toggleCreateContractModal() {
      this.showContractModal = !this.showContractModal;
    },
    createContract(contract) {
      this.$store.dispatch("createProjectContract", contract);
    },
    updateContract(contract) {
      this.$store.dispatch("updateProjectContract", contract);
    },
    deleteContract(id) {
      sweetAlert({
        title: "Confirmation",
        text: "Are you sure you want to delete this contract?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.value) {
          this.$store.dispatch("deleteContract", id);
        }
      });
    },
  },
  watch: {
    createProjectContractStatus() {
      if (this.createProjectContractStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Contract has been created successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.init();
        });
      } else if (this.createProjectContractStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Contract creation has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
    updateProjectContractStatus() {
      if (this.updateProjectContractStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Contract has been updated successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.init();
        });
      } else if (this.updateProjectContractStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Contract update has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
    deleteProjectContractStatus() {
      if (this.deleteContractStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Contract has been deleted successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.init();
        });
      } else if (this.deleteProjectContractStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Contract delete has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
  },
};
</script> 
 <style>
.md-ripple {
  padding: 0px !important;
}
.table.vgt-table {
  font-size: 20px;
}
.form-control {
  border: 1px solid #ced4da !important;
  background-image: none;
  border-radius: 5px !important;
  background-color: rgb(250, 250, 247) !important;
}
.custom-select {
  background-color: #fafaf7;
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/projectContracts.vue